const styles = {
  page: {
    minHeight: "100vh",
    background: "#f0f5ff",
    fontFamily: "'Nunito', sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
    position: "relative",
    overflow: "hidden",
  },
  blob1: {
    position: "fixed",
    width: 520, height: 520,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(107,147,251,0.18) 0%, transparent 70%)",
    top: -100, left: -120,
    pointerEvents: "none",
    zIndex: 0,
  },
  blob2: {
    position: "fixed",
    width: 420, height: 420,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(59,110,248,0.12) 0%, transparent 70%)",
    bottom: -80, right: -100,
    pointerEvents: "none",
    zIndex: 0,
  },
  wrapper: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "2rem",
    width: "100%",
    maxWidth: 540,
  },
  logo: {
    width: 110, height: 110,
    background: "#ffffff",
    borderRadius: 28,
    boxShadow: "0 8px 30px rgba(59,110,248,0.15)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logoText: {
    fontFamily: "'Nunito', sans-serif",
    fontSize: "1.7rem",
    fontWeight: 800,
    color: "#3b6ef8",
    letterSpacing: "0.04em",
  },
  card: {
    background: "#ffffff",
    border: "1.5px solid #d4e0ff",
    borderRadius: 24,
    padding: "3rem 2.75rem 2.5rem",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 4px 40px rgba(59,110,248,0.09), 0 1px 4px rgba(0,0,0,0.04)",
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.45rem",
    background: "#dce8ff",
    borderRadius: 999,
    padding: "0.38rem 1rem",
    fontSize: "0.75rem",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#1a47d0",
    margin: "0 auto 1.6rem",
  },
  dot: {
    width: 7, height: 7,
    borderRadius: "50%",
    background: "#3b6ef8",
    animation: "blink 2s ease-in-out infinite",
  },
  h1: {
    fontSize: "clamp(1.9rem, 5vw, 2.6rem)",
    fontWeight: 800,
    color: "#1e2a4a",
    lineHeight: 1.15,
    letterSpacing: "-0.01em",
    marginBottom: "1rem",
  },
  divider: {
    width: 48, height: 3,
    background: "linear-gradient(90deg, #3b6ef8, #6b93fb)",
    borderRadius: 999,
    margin: "0 auto 1.4rem",
  },
  message: {
    fontSize: "1rem",
    lineHeight: 1.75,
    color: "#6b7a99",
    marginBottom: "2rem",
  },
  etaRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
    background: "#f0f5ff",
    border: "1.5px solid #d4e0ff",
    borderRadius: 14,
    padding: "1rem 1.5rem",
    marginBottom: "1.5rem",
  },
  etaIcon: {
    width: 38, height: 38,
    background: "#dce8ff",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  etaText: { textAlign: "left" },
  etaLabel: {
    fontSize: "0.72rem",
    fontWeight: 700,
    letterSpacing: "0.07em",
    textTransform: "uppercase",
    color: "#6b7a99",
    marginBottom: "0.15rem",
  },
  etaValue: {
    fontSize: "0.96rem",
    fontWeight: 700,
    color: "#1e2a4a",
  },
  countdownRow: {
    display: "flex",
    justifyContent: "center",
    gap: "0.75rem",
  },
  countBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "#dce8ff",
    borderRadius: 12,
    padding: "0.6rem 1rem",
    minWidth: 60,
  },
  countNum: {
    fontSize: "1.6rem",
    fontWeight: 800,
    color: "#3b6ef8",
    lineHeight: 1,
  },
  countLabel: {
    fontSize: "0.65rem",
    fontWeight: 700,
    color: "#6b7a99",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    marginTop: 4,
  },
  footer: {
    fontSize: "0.78rem",
    color: "#6b7a99",
    fontWeight: 500,
  },
  footerLink: {
    color: "#3b6ef8",
    textDecoration: "none",
    fontWeight: 600,
  },
};

export default styles;